import styled from "styled-components";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import ReadMoreIcon from "@mui/icons-material/ReadMore";
import { VideoResult } from "common/video/dto/VideoResult";
import { NavLink } from "react-router-dom";
import { useSakusasVideoDelete } from "hooks/sakusas/video/useSakusasVideoDelete";
import { QUERY_KEYS } from "constant/react_query";
import { videoLinkSingle } from "common/video/video_link_common";
import useConfirm from "common/modal/ConfirmDialog";

type VideoSingleNavProps = {
  video: VideoResult;
  hideEditNav?: boolean;
  hideReadNav?: boolean;
};

const VideoSingleNav = ({
  video,
  hideEditNav,
  hideReadNav,
}: VideoSingleNavProps) => {
  const { videoDeleteMutate } = useSakusasVideoDelete({
    invalidateKeys: [QUERY_KEYS.SAKUSAS_VIDEO_SEARCH],
  });

  const actionConfirm = useConfirm();

  const deleteHandle = async () => {
    const check = await actionConfirm({
      title: "Video",
      message: "Are you sure you want to delete video",
    });
    if (check) {
      videoDeleteMutate(video.id);
    }
  };

  return (
    <DivNav>
      <DeleteIcon onClick={deleteHandle} />
      {!hideEditNav && (
        <NavLink to={videoLinkSingle(video.id, true)}>
          <EditIcon />
        </NavLink>
      )}
      {!hideReadNav && (
        <NavLink to={videoLinkSingle(video.id)}>
          <ReadMoreIcon />
        </NavLink>
      )}
    </DivNav>
  );
};

const DivNav = styled.div`
  margin-top: 0.75rem;
  svg {
    margin-left: 1rem;
    cursor: pointer;
  }
  svg:hover {
    opacity: 0.8;
  }
  &&& > svg:first-of-type {
    margin-left: 0;
  }
`;

export default VideoSingleNav;
